import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";

const routePrefix = "/document/";

const DocumentApi = {
	beginSession(ownerId, container) {
		const serviceUrl = prependRoot(routePrefix + "begin/" + ownerId + "/" + container, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});

		return returnValue;
	},

	commitSession(sessionId, ownerId) {
		const serviceUrl = prependRoot(routePrefix + "commit/" + sessionId + "/" + ownerId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});

		return returnValue;
	},

	rollbackSession(sessionId) {
		const serviceUrl = prependRoot(routePrefix + "rollback/" + sessionId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});

		return returnValue;
	},

	listContent(sessionId) {
		const serviceUrl = prependRoot(routePrefix + "content/" + sessionId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});

		return returnValue;
	},

	listContentWithoutCache(ownerId, container, component) {
		const serviceUrl = prependRoot(routePrefix + "contentnocache/" + ownerId + "/" + component, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});

		return returnValue;
	},

	listTemplates(container) {
		const serviceUrl = prependRoot(routePrefix + "templates/" + container, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});

		return returnValue;
	},

	getFileDownloadUrl(sessionId) {
		return prependRoot(routePrefix + "file/" + sessionId + "/", getApiRoot());
	},

	getPdfFileDownloadUrl(tochtId) {
		return prependRoot(routePrefix + "tochtpdf/" + tochtId + "/", getApiRoot());
	},

	getGemeentePdfFileDownloadUrl(tochtId) {
		return prependRoot(routePrefix + "tochtgemeentepdf/" + tochtId + "/", getApiRoot());
	},

	getTemplateDownloadUrl(container) {
		return prependRoot(routePrefix + "template/" + container + "/", getApiRoot());
	},

	uploadFiles(sessionId, component, data) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		data.append("sessionId", sessionId);
		data.append("component", component);

		let returnValue = axios.put(serviceUrl, data, {
			headers: {
				'accept': 'application/json',
				'Accept-Language': 'ne-nl,en;q=0.8',
				'Content-Type': `multipart/form-data; boundary=${data._boundary}`
			}
		});

		return returnValue;
	},

	deleteFile(sessionId, component, filename) {
		const serviceUrl = prependRoot(routePrefix + sessionId + "/" + component + "/" + filename, getApiRoot());
		let returnValue = axios.delete(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});

		return returnValue;
	}
};

export default DocumentApi;
